import { render } from "./DisputeBar.vue?vue&type=template&id=4c5ca9ae&scoped=true"
import script from "./DisputeBar.vue?vue&type=script&lang=js"
export * from "./DisputeBar.vue?vue&type=script&lang=js"

import "./DisputeBar.vue?vue&type=style&index=0&id=4c5ca9ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5ca9ae"]])

export default __exports__